import { useEffect, useState } from "react";
import { mediaCanHover, mediaMobile } from "../core/breakpoints";

function getMatches(query) {
  if (typeof window === "undefined" || !window.matchMedia) return false;
  return window.matchMedia(query).matches;
}

export function useMediaQuery(query) {
  const [matches, setMatches] = useState(() => getMatches(query));

  useEffect(() => {
    if (typeof window === "undefined" || !window.matchMedia) return undefined;

    const media = window.matchMedia(query);
    const onChange = () => setMatches(media.matches);

    onChange();
    if (typeof media.addEventListener === "function") {
      media.addEventListener("change", onChange);
      return () => media.removeEventListener("change", onChange);
    }

    media.addListener(onChange);
    return () => media.removeListener(onChange);
  }, [query]);

  return matches;
}

export function useIsMobile() {
  return useMediaQuery(mediaMobile);
}

export function useCanHover() {
  return useMediaQuery(mediaCanHover);
}
